<div class="col-md-8">
  <div (click)="voltar()" style="cursor: pointer;padding: 2px 20px 0 0;float: left;">
    <i class="fas fa-arrow-left"></i>
  </div>
  <h3 class="mt-4"><strong>Candidaturas</strong> <br></h3>
  <h5 class="mb-4"><strong>Cargo: </strong> {{cargo?.nome}}<br></h5>
</div>


<div class="row">
  <div class="col-md-12">
    <nav>
      <div class="nav nav-tabs nav-fill" id="nav-tab" role="tablist">
        <a class="nav-item nav-link active" id="nav-pendente-tab" data-toggle="tab" href="#nav-pendentes" role="tab" aria-controls="nav-pendentes" >Pendentes</a>
        <a class="nav-item nav-link" id="nav-analisadas-tab" data-toggle="tab" href="#nav-analisadas" role="tab" aria-controls="nav-analisadas" >Analisadas</a>
        <a class="nav-item nav-link" id="nav-deferida-tab" data-toggle="tab" href="#nav-deferidas" role="tab" aria-controls="nav-deferidas" >Deferidas</a>
        <a class="nav-item nav-link" id="nav-indeferida-tab" data-toggle="tab" href="#nav-indeferidas" role="tab" aria-controls="nav-indeferidas" >Indeferidas</a>
      </div>
    </nav>

    <div class="tab-content" id="nav-tabContent">
      <div class="tab-pane fade show active pt-2" id="nav-pendentes" role="tabpanel">
        <app-candidaturas-pendentes></app-candidaturas-pendentes>
      </div>
      <div class="tab-pane fade pt-2" id="nav-analisadas" role="tabpanel">
        <app-candidaturas-analisadas></app-candidaturas-analisadas>
      </div>
      <div class="tab-pane fade pt-2" id="nav-deferidas" role="tabpanel">
        <app-candidaturas-deferidas></app-candidaturas-deferidas>
      </div>
      <div class="tab-pane fade pt-2" id="nav-indeferidas" role="tabpanel">
        <app-candidaturas-indeferidas></app-candidaturas-indeferidas>
      </div>
    </div>
  </div>
</div>
